export const calculateSurcharges = (
  surcharges,
  selectedSurcharges,
  costKey,
  paymentKey
) => {
  return surcharges.reduce(({ costTotal = 0, monthlyTotal = 0 }, surcharge) => {
    const surchargeCost = parseFloat(surcharge[costKey]) || 0
    const surchargeMonthlyPayment = parseFloat(surcharge[paymentKey]) || 0
    const surchargeIsSelected = selectedSurcharges.includes(
      surcharge.SurchargeCode
    )

    if (surchargeIsSelected) {
      return {
        costTotal: costTotal + surchargeCost,
        monthlyTotal: monthlyTotal + surchargeMonthlyPayment,
      }
    }

    return {
      costTotal,
      monthlyTotal,
    }
  }, {})
}
